import React, { useState, useEffect } from 'react';
import { Row,Tag, Col, Input, Select, Divider, Table, Modal, Button, Image } from 'antd';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { fetchData, sendData } from '../../httpRequests';
import { getPharmacyId } from '../../components/Shared';
import { DownloadOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { ExportExcel } from '../../components/ExportExcel/ExportExcel';
import ReportOrder from './ReportOrder';
import { formatter } from '../../components/utils/utils';
const { Search } = Input;
const { Option } = Select;

export default function AdminOrders() {
	const navigate = useNavigate();
	const [filteredOrders, setFilteredOrders] = useState([]);
	const [orders, setOrders] = useState([]);
	const [selectedOrder, setSelectedOrder] = useState({});
	const [showOrderModal, setShowOrderModal] = useState(false);
	const today = Date();
	const [defaultInput, setdefaultInput] = useState('')
	//console.log(today)
	//const [ExcelToExport, setExcelToExport] = useState()


	const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
	const fileExtension = '.xlsx';

	const exportToCSV = (csvData, fileName) => {
		const ws = XLSX.utils.json_to_sheet(csvData);
		const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
		const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
		const data = new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, fileName + fileExtension);
	}

	useEffect(() => {
		const pharmacyId = getPharmacyId();
		if (!pharmacyId) {
			navigate('/login');
			return false;
		}

		checkUserAdmin(pharmacyId);

		const url = '/orders/getOrders';
		fetchData(url).then((response) => {
			if (Object.keys(response).length > 0) {
				const Orders = response['orders'];
				setOrders(Orders);
				setFilteredOrders(Orders);
				
			}
		});

		return () => {
			setOrders([]);
			setSelectedOrder({});
		};
	}, []);

	const checkUserAdmin = (pharmacyId) => {
		const url = '/pharmacies/getPharmacyById';
		const data = {
			id: pharmacyId
		};
		sendData(url, data).then((response) => {
			const pharmacy = response['pharmacy'];
			if (pharmacy.role_id != 4&&pharmacy.role_id!=5) navigate('/orders');
		});

		return false;
	};

	const onSearch = ({target}) => {
		const text = target.value;
		//console.log("onsearch",text,target.value)
		//setTimeout(() => {
			if (text) {
				//console.log("verdadero")
				const filteredOrders2 = filteredOrders.filter(
					(order) =>{
						//console.log("name",order.name)
					 return(	order.code.includes(text) ||
						order.zip_Code.includes(text) ||
					 	//order.city.toLowerCase().includes(text.toLowerCase()) ||
						order.name.toLowerCase().includes(text.toLowerCase())
					)
					}
				);
				setFilteredOrders(filteredOrders2);
			} else {
				setFilteredOrders(orders);
				setdefaultInput('')
			}
		//}//, 1000);
	};

	const handleChange = (value) => {
		console.log(value)
		if (value) {
			setdefaultInput(value)
			const filteredOrders2 = orders.filter((order) => order.order_state_id == value);
			setFilteredOrders(filteredOrders2);
		} else {
			setFilteredOrders(orders);
		}
	};

	const cropDate = (dateStr) => {
		const date = new Date(dateStr);
		return <span>{date.toDateString()}</span>;
	};

	const columns = [
		{ title: 'Order #', dataIndex: 'code', key: 'code' },
		{
			title: 'Status',
			render: ({ order_state_id }) => (
				<span>
					{(order_state_id == 1 && 'Pending') ||
						(order_state_id == 2 && 'Processing') ||
						(order_state_id == 3 && 'Ready for pick up by delivery') ||
						(order_state_id == 4 && 'On the way') ||
						(order_state_id == 5 && 'Delivered') ||
						(order_state_id == 6 && 'Rejected') ||
						(order_state_id == 7 && 'Ready to be picked up by client') ||
						(order_state_id == 8 && 'Received by the customer')
}
				</span>
			),
			key: 'order_state_id'
		},
		{
			title: 'For Pickup',
			render: ({ pick_up_status }) => <span>{(pick_up_status == 1 && 'Yes') || 'No'}</span>
		},
		{
			title: 'Date',
			render: ({ created_at }) => cropDate(created_at),
			key: 'created_at',
			defaultSortOrder: 'ascend',
			sorter: {
				compare: (a, b) => new Date(a.created_at) < new Date(b.created_at),
				multiple: 1
			}
		},
		{
			title: 'Time passed',
			render: ({ created_at }) => {
				const date = new Date(created_at);
				const today = new Date();
				let msec = today - date;
				let time = '';

				const dd = Math.floor(msec / 1000 / 60 / 60 / 24);
				msec -= dd * 1000 * 60 * 60 * 24;
				const hh = Math.floor(msec / 1000 / 60 / 60);
				msec -= hh * 1000 * 60 * 60;
				const mm = Math.floor(msec / 1000 / 60);
				msec -= mm * 1000 * 60;

				time = mm + 'min';

				if (hh > 0) {
					time = hh + 'hr ' + mm + 'min';
				}
				if (dd > 0) {
					time = dd + 'd ' + hh + 'hr ' + mm + 'min';
				}

				return <span>{time}</span>;
			},
			key: 'created_at',
			defaultSortOrder: 'ascend',
			sorter: {
				compare: (a, b) => new Date(a.created_at) < new Date(b.created_at),
				multiple: 1
			}
		},
		{ title: 'Total $', dataIndex: 'total_order', key: 'total_order' },
		{ title: 'Pharmacy', dataIndex: 'name' }
	];

	const openOrderModal = (order) => {
		setSelectedOrder(order);
		setShowOrderModal(true);
	};

	const closeOrderModal = () => {
		setShowOrderModal(false);
	};
	
	return (
		<div>
			<OrderModal
				selectedOrder={selectedOrder}
				showOrderModal={showOrderModal}
				closeOrderModal={closeOrderModal}
			/>
			<Row gutter={24}>
				<Col span={16}>
					<Search
					//type={'number'}
						size='large'
						placeholder='Search order by order number, city, pharmacy name or zip code'
						onChange={onSearch}
					/>
				</Col>
				<Col span={4}>
					<Select
						placeholder='Select status'
						defaultValue={defaultInput}
						size='large'
						onChange={handleChange}
						style={{ width: '100%' }}
					>
						<Option value=''>All</Option>
						<Option value='1'>Pending</Option>
						<Option value='2'>Proccesing</Option>
						<Option value='3'>Ready for pick up by delivery</Option>
						<Option value='4'>On the way</Option>
						<Option value='5'>Delivered</Option>
						<Option value='6'>Rejected</Option>
						<Option value='7'>Ready to be picked up by client</Option>
						<Option value='8'>Received by the customer</Option>
					</Select>
				</Col>
				<Col span={4}>
				<ExportExcel data={filteredOrders} name={'Report '+today}></ExportExcel>
				</Col>
			</Row>
			<Divider />
			<Row gutter={24}>
				<Col span={24}>
					<Table
						columns={columns}
						dataSource={filteredOrders}
						rowKey={(item) => item.id}
						onRow={(record) => {
							return {
								onClick: () => openOrderModal(record)
							};
						}}
					/>
				</Col>
			</Row>
		</div>
	);
}

function OrderModal({ selectedOrder, showOrderModal, closeOrderModal }) {
	const navigate = useNavigate();
	const [products, setProducts] = useState([]);

	useEffect(() => {
		const url = '/orders/getOrderDetails';
		const data = {
			order_id: selectedOrder.id
		};
		sendData(url, data).then((response) => {
			if (Object.keys(response).length > 0) {
				const orderDetails = response['orderdetail'];
				orderDetails.map((orderDetail) => {
					loadPharmacyProductsById(orderDetail);
				});
			}
		});

		return () => {
			setProducts([]);
		};
	}, [selectedOrder]);

	const loadPharmacyProductsById = (orderDetail) => {
		const url = '/products/getPharmaciesProductByid';
		const data = {
			pharmacy_id: selectedOrder.pharmacy_id,
			id: orderDetail.pharmacy_product_id
		};
		sendData(url, data).then((response) => {
			const product = response['pharmacyProduct'];
			product.order_quantity = orderDetail.quantity;
			orderDetail.gift_status_id == 1 ? (product.gift_status = 'Yes') : (product.gift_status = 'No');
			product.gift_from = orderDetail.from;
			product.gift_message = orderDetail.message;
			product.order_total = orderDetail.total_product;
			setProducts((prevState) => [...prevState, product]);
		});
	};

	const columns = [
		{
			title: '',
			render: ({ product_img }) => (
				<div
					style={{
						width: 40
					}}
				>
					<Image src={product_img} />
				</div>
			),
			key: 'product_img'
		},
		{
			title: 'Name',
			dataIndex: 'product_name',
			key: 'product_name'
		},
		{
			title: 'Price $',
			render: ({ price }) => (formatter.format(price)),
			key: 'price'
		},
		{
			title: 'Quantity',
			render: ({ ...data }) => (
				<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>
					<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>
						
					</div>
					<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '10px' }}>
						<div style={{ margin: 'auto', justifyContent: 'center', alignItems: 'center' }}>
							{data.order_quantity}
						</div>
					</div>
					<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>

					
					</div>
				</div>


			),
			key: 'order_quantity'
		},
		// {
		// 	title: 'Send as a gift',
		// 	//dataIndex: 'gift_status',
		// 	key: 'gift_status'
		// },
		{
			title: 'From (gift)',
			render:({gift_from})=>(
				<span>{gift_from?gift_from:'No message set'}</span>
			),
			//dataIndex: 'gift_from',
			key: 'gift_from'
		},
		{
			title: 'Message (gift)',
			render:({gift_message})=>(
				<span>{gift_message?gift_message:'No message set'}</span>
			),
			//dataIndex: 'gift_message',
			key: 'gift_message'
		},
		{
			title: 'Client',
			//dataIndex: 'clientName',
			render:({first_name,last_name})=>(
				<span>{first_name+' '+last_name}</span>
			),
			key: 'clientName'
		},
		{
			title: 'phone',
			colSpan:1,
			render:({phone,text})=>(
				<span>{phone.replace(/^(\d{3})(\d{3})(\d{4}).*/, '+1($1)-$2-$3')}</span>
			),
			key: 'phone',
			
		},
		{
			title: 'Address',
			//dataIndex: 'clientName',
			render:({address_1,address_2})=>(
				<span>{(address_2?address_1+' | '+address_2:address_1)}</span>
			),
			key: 'Address'
		},
	
		{ title: 'Order total $', render: ({ ...data }) => (<span>{formatter.format(data.order_quantity * data.price)}</span>), key: 'order_total' },
	];

	
	const getOrderDateTime = () => {
		const date = new Date(selectedOrder.created_at);
		const today = new Date();
		let msec = today - date;
		let time = '';

		const dd = Math.floor(msec / 1000 / 60 / 60 / 24);
		msec -= dd * 1000 * 60 * 60 * 24;
		const hh = Math.floor(msec / 1000 / 60 / 60);
		msec -= hh * 1000 * 60 * 60;
		const mm = Math.floor(msec / 1000 / 60);
		msec -= mm * 1000 * 60;

		time = mm + 'min';

		if (hh > 0) {
			time = hh + 'hr ' + mm + 'min';
		}
		if (dd > 0) {
			time = dd + 'd ' + hh + 'hr ' + mm + 'min';
		}

		return time;
	};

	const getOrderCreatedTime = () => {
		const date = new Date(selectedOrder.created_at);
		return date.toDateString();
	};

	return (
		<Modal
			visible={showOrderModal}
			onCancel={closeOrderModal}
			title={'Order details'}
			width={800}
			footer={[
				<Button key='back' onClick={closeOrderModal}>
					Close
				</Button>
			]}
		>
			<div>
				{Object.keys(selectedOrder).length > 0 && (
					<div style={{ textAlign: 'center', marginBottom: 20 }}>
						<h2>Order: #{selectedOrder.code}</h2>
						<div
							style={{
								display: 'flex',
								justifyContent: 'space-around',
								alignItems: 'center',
								marginTop: 30
							}}
						>
							<h3>
								Status:{''}
								{(selectedOrder.order_state_id == 1 && 'Pending') ||
									(selectedOrder.order_state_id == 2 && 'Processing') ||
									(selectedOrder.order_state_id == 3 && 'Ready for pick up') ||
									(selectedOrder.order_state_id == 4 && 'On the way') ||
									(selectedOrder.order_state_id == 5 && 'Delivered') ||
									(selectedOrder.order_state_id == 6 && 'Rejected') ||
									(selectedOrder.order_state_id == 7 && 'Ready to be picked up by client')}
							</h3>
							<div>
								<h3>Pharmacy: {selectedOrder.name}</h3>
								<Button
									onClick={() => navigate('/admin/pharmacyDetails/' + selectedOrder.pharmacy_id)}
									type='primary'
									style={{ borderRadius: 10, width: 130, marginLeft: 10, height: 40 }}
								>
									Go to pharmacy
								</Button>
							</div>
						</div>
						<div
							style={{
								display: 'flex',
								justifyContent: 'space-around',
								alignItems: 'center',
								marginTop: 30
							}}
						>
							<h3>Created at: {getOrderCreatedTime()}</h3>
							<h3>Time since created: {getOrderDateTime()}</h3>
						</div>
						<Divider />
						{Object.keys(products).length > 0 && (
							<>
								<Table
									columns={columns}
									dataSource={products}
									scroll={{x:800}}
									rowKey={(item) => item.product_pharmacy_id}
									pagination={false}
								/>
							</>
						)}
					</div>
				)}
			</div>
		</Modal>
	);
}

OrderModal.propTypes = {
	selectedOrder: PropTypes.object,
	showOrderModal: PropTypes.bool,
	closeOrderModal: PropTypes.func
};
